export const environment = {
  production: false,
  version: '5.2.0',
  mockData: false,
  apiUrl: 'https://tg-api.starexchange.dev',
  hasDarkTheme: false,
  devMode: true,
  linkWebVersion: 'https://aml-dev.starexchangealliance.com'
};
